export default "__VITE_ASSET__Cqc$C_o7__"